import "./Mixes.scss";

import React from "react";
import { inject, observer } from "mobx-react";
import { RouteNode } from "react-router5";

import Frame from "../Frame/Frame";
import Popup from "../../Components/Popup/Popup";
import Button from "../../Components/Button/Button";

import { STORE_CONFIG } from "../../Store/ConfigStore";
import { ROUTE_MIX, ROUTE_MIXES } from "../../routes";
import { STORE_MIXES } from "../../Store/MixesStore";
import { STORE_AUTH } from "../../Store/AuthStore";

import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);

import XLSX from "xlsx";

import {
  formatDate,
  formatDateOnly,
  fixFloat,
  formatNumber,
} from "../../utility";

import Select from "react-select";
import { SelectStyle, DropdownIndicator } from "../App/select_style";

@inject((stores) => ({
  store: stores.store.get(STORE_MIXES),
  configStore: stores.store.get(STORE_CONFIG),
  authStore: stores.store.get(STORE_AUTH),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class Mix extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popup: "none",
      popupText: "",
      itemselector: false,
      addressselector: null,
      saving: false,
    };

    this.getMixedPallet();
  }

  componentDidMount() {
    const { route, store } = this.props;
    if (route.params.hasOwnProperty("editedId")) {
      store.setEditedId(route.params.editedId);
      this.getMixedPallet();
    }
  }

  getMixedPallet = () => {
    const { store, socket } = this.props;
    if (store.selectedpallets.length > 0) {
      const _this = this;
      socket.emitWithToken(
        "GetMixedPallet",
        { Ids: store.selectedpallets },
        function (err, data) {
          if (err) {
            console.error(err);
          } else if (data) {
            console.log(data);
            if (data.Error) {
              _this.setState({
                popup: "error",
                popupText: data.Error,
              });
            } else {
              if (data.Comment) {
                _this.setState({
                  popup: "result",
                  popupText: data.Comment,
                });
              }

              store.setMixedPallet(data);
            }
          }
        }
      );
    }
  };

  showPopup = (text) => {
    this.setState({ popup: "result", popupText: text });
  };

  save = () => {
    const { store, socket, authStore } = this.props;
    const { mixedPallet, mixedItems, selectedpallets } = store;

    const items = [];
    let sumRatio = 0;
    for (const mixeditem of mixedItems) {
      if (!mixeditem.item) {
        this.showPopup("Faj megadása kötelező.");
        return;
      }
      if (!mixeditem.subitem) {
        this.showPopup("Fajta megadása kötelező.");
        return;
      }
      if (!mixeditem.cleaningrate) {
        this.showPopup("Fok megadása kötelező.");
        return;
      }
      if (!mixeditem.ratio) {
        this.showPopup("Arány megadása kötelező.");
        return;
      }
      if (!mixeditem.deleted) sumRatio += mixeditem.ratio;
      items.push({
        Id: mixeditem.id,
        ItemId: mixeditem.subitem,
        SealNum: mixeditem.sealnum || null,
        CleaningRateId: mixeditem.cleaningrate,
        Ratio: mixeditem.ratio,
        Deleted: mixeditem.deleted,
      });
    }

    if (sumRatio > 100) {
      this.showPopup("Az arányok összege nem lehet nagyobb 100%-nál.");
      return;
    }

    const data = {
      PalletIds: selectedpallets,
      User: authStore.user.Id,
      Items: items,
    };

    const _this = this;
    this.setState({ saving: true });
    socket.emitWithToken("SetMixedPalletItems", data, function (err, data) {
      _this.setState({ saving: false });

      if (err) {
        console.error(err);
        _this.showPopup(err);
      } else {
        _this.showPopup("Sikeres mentés.");
      }
    });
  };

  back = () => {
    const { store, router } = this.props;
    store.setSelectedPallets([]);
    store.resetMixedPallet();
    router.navigate(ROUTE_MIXES, { back: true });
  };

  handleDownload() {
    const { configStore, store } = this.props;
    const { mixedItems, mixedPallet } = store;

    const merges = [];

    const data1 = [
      [
        "Azonosító",
        "Fémzárszám",
        "Beszállító",
        "Mennyiség",
        "Hely",
        "Létrehozva",
      ],
    ];
    for (let i = 0; i < mixedPallet.Pallets.length; i++) {
      const pallet = mixedPallet.Pallets[i];
      data1.push([
        pallet.LotNo,
        pallet.SealNum,
        pallet.Supplier,
        pallet.QuantityText,
        pallet.BinCodeText,
        pallet.Created,
      ]);
    }

    const data2 = [
      ["Cikk", mixedPallet.Data.ItemName, "", "Keverék tételek"],
      [
        "Gép",
        mixedPallet.Data.MachineText,
        "",
        "Faj/fajta",
        "Fémzárszám",
        "Fok",
        "Arány (%)",
        "Mennsiség (kg)",
      ],
      ["Fok", mixedPallet.Data.CleaningRateText],
      ["Összennyiség", mixedPallet.Data.QuantityText],
    ];

    let sumRatio = 0;
    const itemsRowStart = 2;
    for (let i = 0; i < mixedItems.length; i++) {
      const mixedItem = mixedItems[i];
      const itemName = configStore.items[mixedItem.subitem] || "";

      if (!mixedItem.item) {
        this.showPopup("Faj megadása kötelező.");
        return;
      }
      if (!mixedItem.subitem) {
        this.showPopup("Fajta megadása kötelező.");
        return;
      }
      if (!mixedItem.cleaningrate) {
        this.showPopup("Fok megadása kötelező.");
        return;
      }
      if (!mixedItem.ratio) {
        this.showPopup("Arány megadása kötelező.");
        return;
      }

      if (!mixedItem.deleted) {
        sumRatio += mixedItem.ratio;

        const itemData = [
          itemName,
          mixedItem.sealnum || "",
          configStore.cleaningRates[mixedItem.cleaningrate],
          mixedItem.ratio,
          { t: "n", v: mixedItem.quantity },
        ];

        if (data2[i + itemsRowStart]) {
          data2[i + itemsRowStart] = data2[i + itemsRowStart].concat(
            [""].concat(itemData)
          );
        } else {
          data2.push(["", "", ""].concat(itemData));
        }
      }
    }

    if (sumRatio > 100) {
      this.showPopup("Az arányok összege nem lehet nagyobb 100%-nál.");
      return;
    }

    var wb = XLSX.utils.book_new();
    var ws1 = XLSX.utils.aoa_to_sheet(data1);
    ws1["!merges"] = merges;
    XLSX.utils.book_append_sheet(wb, ws1, "Raklapok");
    var ws2 = XLSX.utils.aoa_to_sheet(data2);
    ws2["!merges"] = merges;
    XLSX.utils.book_append_sheet(wb, ws2, "Keverék tételek");

    XLSX.writeFile(
      wb,
      "Keverék (" +
        mixedPallet.Data.ItemName +
        " - " +
        mixedPallet.Pallets.map((pallet) => pallet.LotNo).join(",") +
        ")" +
        ".xlsx",
      {
        bookSST: true,
        compression: true,
      }
    );
  }

  render() {
    const { store, configStore, authStore, route, router, socket } = this.props;
    const { mixedPallet, mixedItems } = store;
    console.log(mixedPallet);
    const params = [
      { name: "Cikk", value: mixedPallet ? mixedPallet.Data.ItemName : "-" },
      { name: "Gép", value: mixedPallet ? mixedPallet.Data.MachineText : "-" },
      {
        name: "Fok",
        value: mixedPallet ? mixedPallet.Data.CleaningRateText : "-",
      },
      {
        name: "Összmennyiség",
        value: mixedPallet ? mixedPallet.Data.QuantityText : "-",
      },
    ];
    const items = Object.values(configStore.itemsStructure.Items)
      .map((item) => {
        return { value: item.id, label: item.name };
      })
      .sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
    const subitems = Object.values(configStore.itemsStructure.Subitems)
      .map((subitem) => {
        return { value: subitem.id, label: subitem.name, item: subitem.itemId };
      })
      .sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
    const cleaningrates = Object.entries(configStore.cleaningRates).map(
      ([key, value]) => ({
        value: key,
        label: value,
      })
    );
    return (
      <Frame>
        <div className="table basic-content">
          <div className="table__top">
            <div className="table__top-backpanel">
              <Button
                className="mixedPallet__editbutton"
                onClick={() => this.back()}
              >
                Vissza
              </Button>
              <div className="table__top-pagename">Keverék részletek</div>
            </div>

            <Button
              className="mixedPallet__editbutton"
              onClick={() => this.handleDownload()}
            >
              Excel letöltés
            </Button>

            <div className="table__top-backpanel">
              {
                <Button
                  className="mixedPallet__editbutton"
                  disabled={this.state.saving}
                  onClick={() => this.save()}
                >
                  Mentés
                </Button>
              }
            </div>
          </div>
          <div className="masterdata_form_frame">
            <div className="masterdata_form">
              {params.map((param) => {
                return (
                  <div className="formfield">
                    <div className="formfield_label">{param.name}</div>
                    <div className="formfield_input">
                      <span className="formfield_input-label">
                        {param.value}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="items-field">
              <div className="items-subfield">
                <div className="items-field-title">Raklapok</div>
                <div className="items-field-headers">
                  <div className="items-field-header">Azonosító</div>
                  <div className="items-field-header">Fémzárszám</div>
                  <div className="items-field-header">Beszállító</div>
                  <div className="items-field-header">Mennyiség</div>
                  <div className="items-field-header">Hely</div>
                  <div className="items-field-header">Létrehozva</div>
                </div>
                {mixedPallet &&
                  mixedPallet.Pallets.map((pallet, idx) => {
                    return (
                      <div key={idx + 1} className={"items-field-item"}>
                        <div className="items-field-item-prop">
                          <span className="items-field-item-prop-label">
                            {pallet.LotNo || ""}
                          </span>
                        </div>
                        <div className="items-field-item-prop">
                          <span className="items-field-item-prop-label">
                            {pallet.SealNum || ""}
                          </span>
                        </div>
                        <div className="items-field-item-prop">
                          <span className="items-field-item-prop-label">
                            {pallet.Supplier || ""}
                          </span>
                        </div>
                        <div className="items-field-item-prop">
                          <span className="items-field-item-prop-label">
                            {pallet.QuantityText || ""}
                          </span>
                        </div>
                        <div className="items-field-item-prop">
                          <span className="items-field-item-prop-label">
                            {pallet.BinCodeText || ""}
                          </span>
                        </div>
                        <div className="items-field-item-prop">
                          <span className="items-field-item-prop-label">
                            {pallet.Created || ""}
                          </span>
                        </div>
                      </div>
                    );
                  })}
              </div>

              <div className="items-subfield">
                <div className="items-field-title">Tételek</div>
                <div className="items-field-headers">
                  <div className="items-field-header">Faj</div>
                  <div className="items-field-header">Fajta</div>
                  <div className="items-field-header">Fémzárszám</div>
                  <div className="items-field-header">Fok</div>
                  <div className="items-field-header">Arány (%)</div>
                  <div className="items-field-header">Mennyiség (kg)</div>
                  <Button
                    className="items-field-button"
                    onClick={() => store.addMixedItem()}
                  >
                    Új
                  </Button>
                </div>
                {mixedItems &&
                  mixedItems.map((mixeditem, idx) => {
                    if (mixeditem.deleted) return null;
                    return (
                      <div key={idx + 1} className={"items-field-item"}>
                        <div className="items-field-item-prop">
                          <Select
                            className="react-select sarzs-select"
                            options={items}
                            value={items.find(
                              (e) => e.value === mixeditem.item
                            )}
                            onChange={(option) => {
                              store.setMixedItemItem(idx, option.value);
                            }}
                            isClearable={false}
                            isSearchable={false}
                            styles={SelectStyle}
                            components={{ DropdownIndicator }}
                            placeholder="Válasszon fajt..."
                            maxMenuHeight={250}
                          />
                        </div>
                        <div className="items-field-item-prop">
                          <Select
                            className="react-select sarzs-select"
                            options={
                              mixeditem.item
                                ? subitems.filter(
                                    (s) => s.item === mixeditem.item
                                  )
                                : subitems
                            }
                            value={
                              !mixeditem.subitem
                                ? null
                                : subitems.find(
                                    (e) => e.value === mixeditem.subitem
                                  )
                            }
                            onChange={(option) => {
                              store.setMixedItemSubitem(idx, option.value);
                            }}
                            isClearable={false}
                            isSearchable={false}
                            styles={SelectStyle}
                            components={{ DropdownIndicator }}
                            placeholder="Válasszon fajtát..."
                            maxMenuHeight={250}
                          />
                        </div>
                        <div className="items-field-item-prop">
                          <div className="items-field-item-prop-inner">
                            <input
                              className="edit-input items-field-input"
                              value={mixeditem.sealnum}
                              onChange={(e) =>
                                store.setMixedItemSealnum(idx, e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="items-field-item-prop">
                          <Select
                            className="react-select sarzs-select"
                            options={cleaningrates}
                            value={cleaningrates.find(
                              (e) => e.value === mixeditem.cleaningrate
                            )}
                            onChange={(option) => {
                              store.setMixedItemCleaningRate(idx, option.value);
                            }}
                            isClearable={false}
                            isSearchable={false}
                            styles={SelectStyle}
                            components={{ DropdownIndicator }}
                            placeholder="Válasszon fokot..."
                            maxMenuHeight={250}
                          />
                        </div>
                        <div className="items-field-item-prop">
                          <div className="items-field-item-prop-inner">
                            <input
                              className="edit-input items-field-input"
                              value={mixeditem.ratio}
                              onChange={(e) =>
                                store.setMixedItemRatio(idx, e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="items-field-item-prop">
                          <span className="items-field-item-prop-label">
                            {mixeditem.quantity || ""}
                          </span>
                        </div>
                        <Button
                          className="items-field-button"
                          onClick={() => store.deleteMixedItem(idx)}
                        >
                          x
                        </Button>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>

        {(this.state.popup === "error" || this.state.popup === "result") && (
          <Popup
            key="popup"
            text={this.state.popupText}
            buttons={[
              <Button
                className="popup_button"
                onClick={(e) => {
                  this.setState({ popup: "none" });
                  if (this.state.popup === "error") this.back();
                }}
              >
                Ok
              </Button>,
            ]}
            onClickClose={() => {
              this.setState({ popup: "none" });
              if (this.state.popup === "error") this.back();
            }}
          />
        )}
        {this.state.popup === "delete" && (
          <Popup
            key="popup"
            text="Biztosan törli?"
            buttons={[
              <Button
                className="popup_button"
                onClick={() => {
                  this.setState({ popup: "none" });
                  this.delete();
                }}
              >
                Igen
              </Button>,
              <Button
                className="popup_button"
                onClick={(e) => {
                  this.setState({ popup: "none" });
                }}
              >
                Mégse
              </Button>,
            ]}
            onClickClose={() => this.setState({ popup: "none" })}
          />
        )}
      </Frame>
    );
  }
}

export default (props) => (
  <RouteNode nodeName={ROUTE_MIX}>
    {(routeProps) => <Mix {...routeProps} {...props} />}
  </RouteNode>
);
